'use client';

import { Box, Tooltip } from '@mui/material';
import React from 'react';

export interface StatusConfig {
  title: string;
  iconColor: string;
  backgroundColor: string;
  icon: string;
}

export const StatusIcon = React.forwardRef<
  HTMLSpanElement,
  {
    status: string;
    configMap: Record<string, StatusConfig>;
    hideTooltip?: boolean;
  }
>(({ status, configMap, hideTooltip }, ref) => {
  const config = configMap[status];
  if (!config) return null;

  return (
    <Tooltip title={hideTooltip ? undefined : config.title}>
      <Box
        ref={ref}
        component='span'
        className='rounded-full inline-flex p-[2px]'
        sx={{
          background: config.backgroundColor,
          '& i': { background: config.iconColor },
        }}
      >
        <i className={`${config.icon} h-[20px] w-[20px]`} />
      </Box>
    </Tooltip>
  );
});

StatusIcon.displayName = 'StatusIcon';
